// extracted by mini-css-extract-plugin
export default {"modal":"DownloadModal_modal__SCL9Y","container":"DownloadModal_container__l04lj","buttonDownload":"DownloadModal_buttonDownload__uFGR-"};